export const attachmentItem = {
    title: "Voir le détail de la pièce jointe",
    'create-by': "créé par {owner}",
}